<template>
  <div class="loginindex1">
    <img class="logo" src="../assets/loginlogo.png" />
    <div class="logotitle">猎头互助平台 / 猎头好帮手 / 找好猎头上聘快快</div>
    <div class="rightbox">
      <div class="logoBody">
        <div class="statusbox" v-if="loginStatus">
          <p class='qrtext1'>登录中.....</p>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogFormVisible" :close-on-press-escape="false" :close-on-click-modal="false"
      :show-close="false">
      <el-form :model="form">
        <el-result icon="warning" title="聘快快PA版为邀请制"
          subTitle="为了保证平台职位真实有效，发布人（PA）需要经过平台审核，签订合同。">
        </el-result>
        <el-form-item label="手机号码" :label-width="formLabelWidth">
          <el-input v-model="phone" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="go1()">取 消</el-button>
        <el-button type="primary" @click="go2()">查询申请情况</el-button>
        <el-button type="primary" @click="go3()">提交申请</el-button>
      </div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogFormVisible1">
      <el-form :model="form">
        <el-result icon="success" title="提交成功" subTitle="平台将于3个工作日内与您联系，并进行资料审核">
        </el-result>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible1 = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Config from "../config/index";
import { setInterval } from "timers";
import moment from 'moment';
let QRCode = require("qrcode");
export default {
  name: "loginRe",
  props: {},
  data() {
    return {
      uuid: "",
      qrUrl: "",
      qrloading: false,
      loginZt: "hr",
      compLoading: false,
      companyEmail: "",
      companyPassword: "",
      loginStatus: true,
      code: "",
      userInfo: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      phone: ""
    };
  },
  watch: {},
  created: function () { },
  methods: {
    getUrlParams: function (url) {
      let urlStr = url.split('?')[1]
      let obj = {};
      let paramsArr = urlStr.split('&')
      for (let i = 0, len = paramsArr.length; i < len; i++) {
        let arr = paramsArr[i].split('=')
        obj[arr[0]] = arr[1];
      }
      return obj
    },
    go1: function () {
      window.location.href = 'https://www.pinkuaikuai.cn/login.html'
    },
    go2: function () {
      let that = this;
      let url = Config.path + "/api/enterprise/getApplyEnterpriseUser";
      axios({
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
          token: this.userInfo.token
        }
      })
        .then(function (response) {
          console.log(response);
          if (response.data.success === "1") {
            that.dialogFormVisible1 = true
          } else {
            that.$message({
              message: response.data.message,
              type: "warning"
            });
          }
        })
        .catch(function (error) {
          that.loading = false;
          console.log(error);
        });
    },
    go3: function () {
      let that = this;
      if (that.phone !== "") {
        that.$message({
          message: "请填写您个人的手机号码",
          type: "warning"
        });
      }
      let url = Config.path + "/api/enterprise/applyEnterpriseUser";
      axios({
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
          token: this.userInfo.token
        },
        data: {
          phone: that.phone
        }
      })
        .then(function (response) {
          console.log(response);
          if (response.data.success === "1") {
            that.dialogFormVisible1 = true
          } else {
            that.$message({
              message: response.data.message,
              type: "warning"
            });
          }
        })
        .catch(function (error) {
          that.loading = false;
          console.log(error);
        });
    },
    goLogin: function () {
      let that = this;
      let url = Config.path + "/api/common/auth/web/login";
      axios({
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json"
        },
        data: {
          "code": this.code,
          "loginType": "2"
        }
      })
        .then(function (response) {
          console.log(response);
          debugger
          if (response.data.success === "1") {
            let data = response.data.content
            if (data.isbindEnterprise) {
              that.$store.commit("setUser", data);
              console.log(that.$store.state);
              localStorage.setItem("loginTime", moment().format('YYYY-MM-DD'));
              localStorage.setItem("token", data.token);
              localStorage.setItem("nickname", data.nickname);
              localStorage.setItem("avatarPath", data.avatarPath);
              that.$notify({
                title: "提示",
                message: "登录成功",
                type: "success",
                duration: 1000
              });
              that.$router.push({
                path: "/myReceiveResume"
              });
            } else {
              that.userInfo = data
              that.dialogFormVisible = true
            }
          } else {
            that.$message({
              message: response.data.message,
              type: "warning"
            });
          }
        })
        .catch(function (error) {
          that.loading = false;

          // eslint-disable-next-line
          console.log(error);
        });
    }
  },
  mounted: function () {
    let u = window.location.href
    let obj = this.getUrlParams(u)
    let code = obj.code
    this.code = code
    this.goLogin()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.loginindex1 {
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-image: url('../assets/loginbg.png');
  background-position: center top;
  background-size: 100% auto;
  background-repeat: no-repeat;
  min-height: 100vh;

  .logo {
    width: 216.5px;
    height: 67.8px;
    margin: 103px auto 0 auto;
  }

  .logotitle {
    color: #ffffff;
    font-size: 18px;
    font-weight: 290;
    line-height: 24px;
    margin-top: 37.6px;
  }

  .statusbox {
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;
  }

  .actionbtn {
    color: #000000;
    padding-top: 20px;
    text-align: center;
  }

  .qrcont {
    margin: 20px auto 0 auto;
    width: 300px;
    height: 300px;
    background-size: 100%, 100%;
  }

  .sumbitBtn {
    width: 100%;
    background: #5cc2cf;
    display: block;
    margin: 0 auto;
  }

  .qrtext1 {
    color: #5cc2cf;
    padding-top: 60px;
    text-align: center;
    padding-bottom: 60px;
  }

  .qrtext2 {
    color: #5cc2cf;
    padding-top: 30px;
    text-align: left;
  }

  .qrtext3 {
    color: #5cc2cf;
    padding-top: 60px;
    padding-bottom: 50px;
    text-align: center;
  }

  .qrtext {
    color: #5cc2cf;
    padding-top: 20px;
    text-align: center;
  }

  .el-tab-pane {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .el-tabs__item {
    color: #ffffff;
  }

  .pkkQrfd {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 150px;
    background-color: transparent;
    border-radius: 8px;
    padding: 20px;
    position: fixed;
    right: 30px;
    bottom: 30px;

    img {
      width: 129px;
      border-radius: 100%;
      padding: 10px;
    }

    p {
      color: #ffffff;
      text-align: center;
      font-size: 12px;
      padding-top: 20px;
    }
  }

  .rightbox {
    width: 410px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 23px;

    .logoBody {
      width: 410px;
      position: relative;
      background-color: #ffffff;
      border-radius: 10px;

      .qrbtn {
        position: absolute;
        right: 5px;
        bottom: 5px;
        width: 100px;
        height: 100px;
      }
    }
  }
}
</style>
